import { render } from "./modalsContainer.vue?vue&type=template&id=6e54a062&scoped=true&ts=true"
import script from "./modalsContainer.vue?vue&type=script&lang=ts"
export * from "./modalsContainer.vue?vue&type=script&lang=ts"

import "./modalsContainer.vue?vue&type=style&index=0&id=6e54a062&scoped=true&lang=css"
import "./modalsContainer.vue?vue&type=style&index=1&id=6e54a062&lang=css"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e54a062"]])

export default __exports__